import React from 'react'

function LoadingScreen() {

  // const logo = new Image();
  // logo.src = "logo-pink-white.jpg"

  return (
    <div style = {{height : '100vh', width : '100%', display: 'flex', position: 'relative'}}>
      <svg style={{margin: 'auto', display: 'block'}} width="400px" height="400px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle cx="50" cy="50" r="44" strokeWidth="7" stroke="#023960" strokeDasharray="69.11503837897544 69.11503837897544" fill="none" strokeLinecap="round">
          <animateTransform attributeName="transform" type="rotate" dur="1.923076923076923s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
        </circle>
        <circle cx="50" cy="50" r="36" strokeWidth="7" stroke="#000000" strokeDasharray="56.548667764616276 56.548667764616276" strokeDashoffset="56.548667764616276" fill="none" strokeLinecap="round">
          <animateTransform attributeName="transform" type="rotate" dur="1.923076923076923s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;-360 50 50"></animateTransform>
        </circle>
      </svg>
        <img src = 'logo.png' style = {{margin : 'auto', position: 'absolute', width: '150px', height: '150px', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}/>
    </div>
  )
}

export default LoadingScreen